import React, { FC, memo } from "react";

interface Props {
  children?: React.ReactNode;
}

const ShortcutTooltipBase: FC<Props> = ({children}: Props) => {

  return (
    <span className="group relative">
      <span
        className={`z-10 whitespace-nowrap rounded-[30px] bg-[#D9F4F0] px-4 py-[6px] text-[#3ABCA8] absolute
        left-1/2 -translate-x-1/2 before:content-[''] before:absolute before:-translate-x-1/2 before:left-1/2 before:top-full before:border-[16px] before:border-transparent before:border-t-[#D9F4F0] group-hover:opacity-100 transition pointer-events-none 
        whitespace-pre-wrap w-max !max-w-[500px] top-[-46px]`}
      >
        <div className={"flex flex-row"}>
          <span className="mt-[4px]">
            <svg width="18" height="18" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line y1="-1" x2="15.0547" y2="-1" transform="matrix(0.603858 0.797092 -0.862525 0.506015 0.5 2)" stroke="#4FB7AD" strokeWidth="2"/>
          </svg>
          </span>
          <span className="font-bold px-[2px] text-base leading-6">まずはここから開始</span>
          <span className="mt-[4px]">
            <svg width="18" height="18" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line y1="-1" x2="15.0547" y2="-1" transform="matrix(-0.603858 0.797092 -0.862525 -0.506015 9.5 0)" stroke="#4FB7AD" strokeWidth="2"/>
            </svg>
          </span>
        </div>
      </span>
      {children}
    </span>
  );
};

export const ShortcutTooltip = memo(ShortcutTooltipBase);
